import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import { FallbackImage } from "@/components/common";
import { ImageGallery } from "@/@types";

type Props = {
  imagesGallery: ImageGallery[];
  setThumbsSwiper: (swiper: any) => void;
  activeIndex: number;
  thumbnailWidth: number;
  thumbnailHeight: number;
  thumbnailObjectFit: "cover" | "contain";
  showNavigationOnThumbnails: boolean;
  showThumbnailsOnMobile: boolean;
};

export default function ThumbnailSlider({
  imagesGallery,
  setThumbsSwiper,
  activeIndex,
  thumbnailWidth,
  thumbnailHeight,
  thumbnailObjectFit,
  showNavigationOnThumbnails,
  showThumbnailsOnMobile,
}: Props) {
  return (
    <div
      className={`sm:absolute sm:-bottom-full left-0 right-0 bg-black/50 p-2 z-10 transition-all duration-300 
                  ${showThumbnailsOnMobile ? "group-hover:-bottom-0" : "sm:group-hover:-bottom-0"
        }`}
    >
      <Swiper
        modules={[Navigation, Thumbs]}
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView="auto"
        watchSlidesProgress
        navigation={showNavigationOnThumbnails}
        className="thumbsSwiper w-full flex justify-center"
      >
        {imagesGallery.map((image, index) => (
          <SwiperSlide key={index} style={{ width: `${thumbnailWidth}px` }}>
            <div
              className={`relative cursor-pointer border-2 transition-all duration-300 
                ${activeIndex === index ? "border-yellow-500 opacity-100" : "border-transparent opacity-50"} 
                hover:border-yellow-500 hover:opacity-100`}
              style={{ width: thumbnailWidth, height: thumbnailHeight }}
            >
              <FallbackImage
                src={image.src}
                alt={`Miniatura ${index + 1}`}
                width={thumbnailWidth}
                height={thumbnailHeight}
                style={{ objectFit: thumbnailObjectFit }}
                className=""
                loading="lazy"
                sizes="320px"
                quality={40}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
